<template lang="pug">
validation-observer(ref='validation')
  .container-cadastro
    .card-header Análise do Processo {{ processo.numeroProcesso }}

    despachos(v-if="!isValidacao" :cadastroColetivo="processo.cadastroColetivo" :despachos="historicoDespachos"  :documentosAssinados="processo.documentosAssinados")
    validacao-edicao-cadastro(v-else :cadastroColetivo="cadastroColetivo" :despachos="historicoDespachos" @validacaoDocumentos="documentos")

    div.container-analise(v-if="!isVisualizar")
      div#despacho
        validation-provider(rules="required", v-slot="{ errors }", name="Despacho")
          app-label(label="Despacho:", :required="true")
          el-input.input(
            type='textarea',
            rows="10",
            v-model="despacho.texto",
            :class="{'erro' : errors.length}",
            @blur="whitespace('texto')"
          )
          span.help.erro {{ errors[0] }}

      div(v-if="isValidacao")
        el-alert(
          title="O upload de anexos dos tipos \"Mapa de localização\" e \"Leitura Mapa\" substituirão os automatizados",
          type="warning",
          show-icon
        )
        app-documentos(
          aba="Anexos",
          :idUploadDocumento="'documentoAnexo'",
          :titulo="'Anexos'",
          :maxSize='25000',
          :valid-extensions="validExtensions",
          :documentos="documentos",
          :tiposDocumentos="tiposDocumentos",
          :tiposDocumentosObrigatorios="[]"
          :pecasTecnicas="true",
          :observer="this.$refs.validation",
        )

      div#anexos(v-else)
        app-label(label="Anexos:", :required="false")
        app-upload-area(
          id="anexo"
          :target="urlUpload"
          :fileType="validExtensions"
          :onSuccess="onSuccess"
          @download="download"
          :documento="despacho.documento"
          @removerDocumento="removerDocumento"
        )

      div
        app-radios-tramitacao(
          v-if="radiosAcoes.length",
          :radios="radiosAcoes",
          :isDecisao="true",
          :radioInicial="radioInicial",
          @changeRadio="changeRadio"
        )

      app-buttons-cadastro(
        :isPrimeiroPasso="true",
        :isUltimoPasso="true",
        :showButtonSalvar="true",
        @salvar="salvar",
        @cancelar="cancelar",
        @finalizar="finalizar"
      )
    div.buttons.btn(v-if="isVisualizar")
      el-button(
          type="default",
          @click="voltar()",
          name="voltar"
        )
          span.center
            i.fas.fa-chevron-left
            b &nbsp Voltar
</template>

<script>
import AppLabel from '@/components/AppLabel'
import AppUploadArea from '@/components/AppUploadArea'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import FileHelper from '@/utils/fileHelper'
import cloneDeep from 'lodash/cloneDeep'
import Despachos from '@/screens/arrecadacao/components/Despachos'
import ValidacaoEdicaoCadastro from '@/screens/arrecadacao/components/ValidacaoEdicaoCadastro'
import { mapActions } from 'vuex'
import BaseAnaliseProcessos from '@/screens/arrecadacao/mixins/BaseAnaliseProcessos'
import rotas from '@/constants/rotas'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos.vue'

const DESPACHO_EMPTY = {
  texto: null,
  documento: null,
  processoId: null,
  despachoId: null,
  acao: null
}

const PROCESSO_EMPTY = {
  numeroProcesso: null,
  cadastroColetivo: {
    dataFinalizacao: null,
    pecaTecnica: {
      geom: null,
      area: 0,
      perimetro: 0,
      municipios: []
    },
    usuario: {
      pessoa: {
        nomeRazaoSocial: ''
      }
    },
    perfil: { nome: '' }
  },
  despachos: []
}

export default {
  components: {
    AppButtonsCadastro,
    AppUploadArea,
    AppLabel,
    AppRadiosTramitacao,
    Despachos,
    ValidacaoEdicaoCadastro,
    AppDocumentos
  },

  props: [
    'routeListagemName',
    'isVisualizar',
    'hasProcesso',
    'routeFinalizar',
    'processoArrecadacao',
    'idProcesso',
    'cadastroColetivo'
  ],

  mixins: [AppNotificacao, BaseAnaliseProcessos],

  data () {
    return {
      validExtensions: ['pdf'],
      documentos: [],
      tiposDocumentos: [
        { descricao: 'Mapa de localização', codigo: 'MAPA_LOCALIZACAO' },
        { descricao: 'Leitura Mapa', codigo: 'LEITURA_MAPA' },
        { descricao: 'Anexo', codigo: 'VALIDACAO' }
      ],
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      processo: cloneDeep(PROCESSO_EMPTY),
      despacho: cloneDeep(DESPACHO_EMPTY),
      radios: {},
      radiosAcoes: [],
      acao: null,
      radioInicial: null,
      historicoDespachos: [],
      isValidacao: this.$route.name === 'gat/validacaoCadastro'
    }
  },

  async created () {
    await this.init()
    this.setDocumentosDespacho()
  },

  watch: {
    processoArrecadacao: {
      handler (val) {
        if (val) {
          this.init()
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      salvarDespacho: 'despachos/save',
      tramitarComAcao: 'processoArrecadacao/tramitarComAcao',
      downloadDocumentos: 'documentoArrecadacao/download',
      salvarCadastroColetivo: 'cadastroColetivo/saveStep',
      findTiposDocumentoTipoProcesso: 'tipoDocumento/findTiposDocumentoTipoProcesso'
    }),

    setDocumentosDespacho () {
      if (this.despacho.documento) {
        this.documentos.push({
          ...this.despacho.documento,
          fileName: this.despacho.documento.nomeOriginal,
          tipoDocumento: {
            ...this.despacho.documento.tipoDocumento,
            descricao: 'Anexo'
          }
        })
      }
    },

    atualizaDocumentos () {
      const docsAdicionados = this.documentos.map(d => d.tipoDocumento.codigo)
      let docsPermanecidos =
        this.cadastroColetivo.pecaTecnica.dadoPecaTecnica.documentos.filter(d => !docsAdicionados.includes(d.tipoDocumento?.codigo))
      this.documentos.forEach(d => docsPermanecidos.push({...d, id: null, isValido: true}))

      return docsPermanecidos.filter(d => d.tipoDocumento.codigo !== 'VALIDACAO')
    },

    atualizaDadosDespacho () {
      const doc = this.documentos.find(d => d.tipoDocumento.codigo === 'VALIDACAO')
      if (doc) {
        return {
          ...this.despacho,
          tipoDespacho: 'VALIDACAO',
          documento: {
            ...doc,
            id: null,
            nomeOriginal: doc.fileName
          }
        }
      }
      return {
        ...this.despacho
      }
    },

    validacaoDocumentos (documentos) {
      this.cadastroColetivo.pecaTecnica.dadoPecaTecnica.documentos = documentos
    },

    async salvar () {
      if (this.isValidacao) {
        await this.salvarCadastroColetivo({
          url: rotas.ARRECADACAO.SALVAR_PECA_TECNICA(
            this.cadastroColetivo.id
          ),
          dados: {
            ...this.cadastroColetivo.pecaTecnica,
            documentos: this.atualizaDocumentos()
          }
        })
      }
      const response = await this.salvarDespacho({
        dados: this.isValidacao ? this.atualizaDadosDespacho() : { ...this.despacho }
      })

      this.setDespacho(response)

      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.ANALISE_SALVA_SUCESSO
      )
    },

    voltar () {
      this.$router.go(-1)
    },

    async finalizar () {
      const response = await this.$refs.validation.validate()

      if (response) {
        if (this.isValidacao) {
          await this.salvarCadastroColetivo({
            url: rotas.ARRECADACAO.SALVAR_PECA_TECNICA(
              this.cadastroColetivo.id
            ),
            dados: {
              ...this.cadastroColetivo.pecaTecnica,
              documentos: this.atualizaDocumentos()
            }
          })
          const response = await this.salvarDespacho({
            dados: this.isValidacao ? this.atualizaDadosDespacho() : { ...this.despacho }
          })

          this.setDespacho(response)
        }
        this.confirmBox(

          this.$messages.MSG_CONFIRMACAO,
          this.$messages.TITULO_WARNING,
          () => {
            this.tramitarComAcao({ ...this.despacho }).then(response => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                response
              )

              this.goToListagem(this.$props.routeFinalizar)
            })
          },
          () => {},
          'Confimar',
          'Cancelar'
        )
      } else {
        this.showErroValidacao(
          this.$messages.ERRO_VALIDACAO_FINALIZAR_ANALISE,
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING
        )
      }
    },

    onSuccess (id, resumableFile, fileKey) {
      let documento = this.despacho.documento

      this.despacho.documento = {
        id: documento ? documento.id : null,
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size,
        removed: false
      }
    },

    async download (id) {
      const documento = this.despacho.documento

      const arrayBuffer = await this.downloadDocumentos({
        fileKey: documento.fileKey,
        id: documento.id
      })

      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },

    removerDocumento () {
      let documento = cloneDeep(this.despacho.documento)

      if (documento.id) {
        documento.removed = true
      } else {
        documento = null
      }

      this.despacho.documento = documento
    },

    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        () => {
          this.goToListagem()
        },
        () => {},
        'Sim',
        'Não'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.container-cadastro {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.container-analise {
  display: flex;
  flex-direction: column;
}

#anexos {
  margin-top: 1rem;
}

#despacho {
  margin-top: 1rem;
}

#confirmacao {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  flex-direction: column;

  >>> .el-checkbox.error-checkbox {
    border: 2px firebrick solid;
  }

  >>> .el-checkbox__label {
    font-weight: bold;
  }

  >>> .el-checkbox__inner {
    border-radius: 10px;
  }
}

>>> .el-textarea__inner {
  resize: none;
}

.label {
  font-weight: bold;
}

.buttons {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/AnaliseProcesso.vue